import {Dispatch, SetStateAction, useMemo, useState} from "react";
import Swal from "sweetalert2";

import {httpRequest} from "~/fetch/common/http-request";

import {MachineDetailRequest, MachineDetailResponse} from "./equipment-detail.interface";

/* --------------------------------- 설비 상세정보 -------------------------------- */
const useMachineDetail = (
    config: MachineDetailRequest,
): [() => Promise<void>, MachineDetailResponse | null, boolean, any, () => Promise<void>, () => Promise<void>] => {
    const [response, setResponse] = useState<MachineDetailResponse | null>(null);
    const [error, setError] = useState<any>(null);
    const [isLoading, setIsLoading] = useState<boolean>(false);

    const request = useMemo(() => {
        const {machineId, companyId, buildingId} = config;
        return httpRequest<MachineDetailRequest, MachineDetailResponse>({
            method: "GET",
            url: "/machine/mv",
            params: {
                companyId,
                buildingId,
                machineId,
            },
        });
    }, [config]);

    const submit = async () => {
        try {
            setIsLoading(true);
            const response = await request.submit();
            setResponse(response.data);
        } catch (e) {
            setError(e);
        } finally {
            setIsLoading(false);
        }
    };

    const historyExcelDownload = async () => {
        return await httpRequest<MachineDetailRequest, Blob>({
            method: "GET",
            url: "/machine/history/excel",
            params: {
                companyId: config.companyId,
                buildingId: config.buildingId,
                machineId: config.machineId,
            },
            responseType: "blob",
        })
            .submit()
            .then((res) => {
                // 파일 다운로드 처리
                const url = window.URL.createObjectURL(new Blob([res.data]));
                const link = document.createElement("a");
                link.href = url;
                // 파일명추출
                const contentType = res.headers["content-type"];
                let fileName = "downloaded_file";
                if (contentType) {
                    const matches = /filename=([^;]*)/.exec(contentType);
                    if (matches != null && matches[1]) {
                        fileName = matches[1].trim().replace(/['"]/g, "");
                    }
                }

                link.setAttribute("download", decodeURIComponent(fileName.replace(/\+/g, " ")));
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);
            })
            .catch((e) => {
                Swal.fire({
                    text: "오류가 발생하였습니다. 다시 시도해주세요",
                    confirmButtonText: "확인",
                });
            });
    };
    const detailExcelDownload = async () => {
        return await httpRequest<MachineDetailRequest, Blob>({
            method: "GET",
            url: "/machine/detail/excel",
            params: {
                companyId: config.companyId,
                buildingId: config.buildingId,
                machineId: config.machineId,
                machineCategoryCode: config.machineCategoryCode,
            },
            responseType: "blob",
        })
            .submit()
            .then((res) => {
                // 파일 다운로드 처리
                const url = window.URL.createObjectURL(new Blob([res.data]));
                const link = document.createElement("a");
                link.href = url;
                // 파일명추출
                const contentType = res.headers["content-type"];
                let fileName = "downloaded_file";
                if (contentType) {
                    const matches = /filename=([^;]*)/.exec(contentType);
                    if (matches != null && matches[1]) {
                        fileName = matches[1].trim().replace(/['"]/g, "");
                    }
                }

                link.setAttribute("download", decodeURIComponent(fileName.replace(/\+/g, " ")));
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);
            })
            .catch((e) => {
                Swal.fire({
                    text: "오류가 발생하였습니다. 다시 시도해주세요",
                    confirmButtonText: "확인",
                });
            });
    };

    return [submit, response, isLoading, error, historyExcelDownload, detailExcelDownload];
};

/* -------------------------------- 설비 게시물 삭제 ------------------------------- */
const useMachineDelete = (
    machineId: number,
    setIsLoading: Dispatch<SetStateAction<boolean>>,
): [() => Promise<void>] => {
    const request = useMemo(() => {
        return httpRequest<{machineId: number}, undefined>({
            method: "DELETE",
            url: "/machine/md",
            data: {
                machineId: machineId,
            },
        });
    }, [machineId]);

    const submit = async () => {
        if (window.confirm("삭제하시겠습니까?")) {
            try {
                setIsLoading(true);
                const res = await request.submit();
            } catch (e) {
                alert("에러가 발생하였습니다 다시 시도해주세요");
            } finally {
                setIsLoading(false);
                alert("삭제되었습니다");
            }
        }
    };

    return [submit];
};

/* ------------------------------- // 설비 상세 수정 ------------------------------- */
// const useMachineUpdateDetail = (config: UpdateDetailRequest): [() => Promise<void>, boolean, any] => {
const useMachineUpdateDetail = (config: any, setIsLoading: any): [() => Promise<void>] => {
    // const [response, setResponse] = useState(null);
    // const [isLoading, setIsLoading] = useState<boolean>(false);
    const [error, setError] = useState<any>(null);

    const request = useMemo(() => {
        // return httpRequest<UpdateDetailRequest, UpdateDetailResponse>({
        return httpRequest<any>({
            method: "PUT",
            url: "/machine/mu",
            data: config,
        });
    }, [config]);

    const submit = async () => {
        if (window.confirm("수정하시겠습니까?")) {
            try {
                setIsLoading(true);
                const res = await request.submit();
                alert("저장되었습니다");
            } catch (e) {
                setError(e);
                alert("에러가 발생하였습니다 다시 시도해주세요");
            } finally {
                setIsLoading(false);
            }
        }
    };

    return [submit];
};

export {useMachineDelete, useMachineDetail, useMachineUpdateDetail};
